'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var alertTheme = require('../../DesignSystem/Styles/alertTheme.js');
var whiteTheme = require('../../DesignSystem/Styles/whiteTheme.js');
var ThemeProvider = require('../../node_modules/@material-ui/styles/esm/ThemeProvider/ThemeProvider.js');
var SvgIcon$1 = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var SvgIcon = React.forwardRef(function (_ref, ref) {
  var color = _ref.color,
      props = objectWithoutProperties(_ref, ["color"]);

  var theme = {
    'alert': alertTheme.alertTheme,
    'white': whiteTheme.whiteTheme
  };

  if (color === 'alert' || color === 'white') {
    return React__default["default"].createElement(ThemeProvider, {
      theme: theme[color]
    }, React__default["default"].createElement(SvgIcon$1["default"], _objectSpread({}, props, {
      color: "primary",
      ref: ref
    })));
  }

  return React__default["default"].createElement(SvgIcon$1["default"], _objectSpread({}, props, {
    color: color,
    ref: ref
  }));
});

module.exports = SvgIcon;
